var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({staticClass:"large-icon-button__container",attrs:{"block":""}},'v-btn',_vm.$attrs,false),[_c('v-icon',{attrs:{"size":48}},[_vm._v(_vm._s(_vm.icon))]),_c('span',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }